/*
    O componente ViewArtigo é responsável por exibir os detalhes de um artigo específico. Ele é renderizado quando o usuário acessa a rota "/ver-artigo/:uuid", onde ":uuid" é um parâmetro dinâmico que representa o identificador único do artigo a ser visualizado. O componente pode utilizar o hook useParams do React Router para extrair o valor do uuid da URL e, em seguida, fazer uma requisição à API para buscar os dados do artigo correspondente. Os detalhes do artigo, como título, conteúdo, autor e data de publicação, podem ser exibidos na tela de forma organizada e estilizada. O componente também pode incluir funcionalidades adicionais, como a possibilidade de voltar para a lista de artigos ou compartilhar o artigo nas redes sociais.
*/
import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Mensagem from "../Mensagem"; // Importa o componente Mensagem para exibir feedback ao usuário
import './ViewArtigo.css'; // Importa o arquivo CSS para estilização do componente
import Botao from "../Botao";
import 'react-quill-new/dist/quill.snow.css';

const ViewArtigo = () => {
    const { uuid } = useParams(); // Captura o UUID da URL
    const navigate = useNavigate(); // Hook para navegação programática
    const location = useLocation(); // Hook para acessar o estado passado pela rota, que pode conter os dados do usuário logado para edição
    const [artigo, setArtigo] = useState(null);
    const [carregando, setCarregando] = useState(true);
    const [mensagem, setMensagem] = useState({ texto: '', tipo: '' });//Controla o state dos dados do componente Mensagem para exibir feedback ao usuário. Tipo recebe o status da resposta da API para definir o estilo da mensagem (ex: sucesso, erro, aviso) para aplicar estilo conforme o tipo recebido, conforme o componente mensagem .

    /**
     * Vamos armazenar os dados do usuário logado para verificar se o artigo é público ou privado, e se for privado, vamos habilitar algumas ferramentas adicionais conforme o tipo de usuário e se for autor ou não. Por exemplo se o artigo for privado, o autor pode ver um botão de "Editar Artigo" que leva para a página de edição do artigo, enquanto outros usuários comuns não verão esse botão. Já os administradores podem ver um botão de "Publicar Artigo" . Para isso, precisamos recuperar os dados do usuário logado e verificar o tipo de usuário e se ele é o autor do artigo para renderizar essas funcionalidades adicionais.
     */
    
    const dadosSalvos = localStorage.getItem('viver_dados');
    const token = localStorage.getItem('viver_token');
    const usuario = dadosSalvos ? JSON.parse(localStorage.getItem('viver_dados')) : null;

    console.log("Dados do usuário logado:", usuario); // Log para verificar os dados do usuário logado  

useEffect(() => {
        const buscarDetalhesArtigo = async () => {

            try {
                const url = `${process.env.REACT_APP_API_URL}/artigo-view?uuid=${uuid}`;
                const resposta = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                        // Adicione o Authorization aqui se o artigo não for público
                    }
                });

                const dadosRetorno = await resposta.json();

                if (dadosRetorno.status === 'sucesso') {
                    setArtigo(dadosRetorno.dados);
                } else {
                    navigate('/resultado', { state: { status: 'erro', mensagem: 'Artigo não encontrado.' } });
                }
            } catch (error) {
                console.error("Erro ao buscar artigo:", error);
                setCarregando(false);
            } finally {
                setCarregando(false);
            }
        };

        if (uuid) {
            buscarDetalhesArtigo();
        }
    }, [uuid, navigate]);

const compartilharArtigo = async () => {
    const urlAtual = window.location.href; // Pega a URL completa (ex: viverespirita.com.br/ver-artigo/uuid)
    const tituloArtigo = "Confira este artigo no Viver Espírita"; 

    if (navigator.share) {
        // Funciona em celulares (Android/iOS) e alguns navegadores desktop modernos
        try {
            await navigator.share({
                title: tituloArtigo,
                url: urlAtual,
            });
            console.log('Compartilhado com sucesso!');
        } catch (err) {
            console.log('Erro ao compartilhar:', err);
        }
        
    } else 
        // Fallback: Copia para a área de transferência se o navegador não der suporte ao share
        try {
            await navigator.clipboard.writeText(urlAtual);
            alert('Link copiado para a área de transferência!');
        } catch (err) {
            console.error('Erro ao copiar link:', err);
            // Fallback final: Exibe o link para o usuário copiar manualmente
            alert("Para compartilhar, copie este link: " + urlAtual);
        }
};


/*Recebe o status atual do artigo e define o novo status a ser enviado para a API de acordo com o status atual. Somente admin e editores podem mudar o status do artigo. 
Status atual 'enviado' -> novo status 'publicado'
Status atual 'publicado' -> novo status 'bloqueado' (para bloquear um artigo já publicado, caso seja necessário retirar ele do ar por algum motivo
Status atual 'bloqueado' -> novo status 'enviado' (para liberar o mesmo para re-publicar um artigo que foi bloqueado)

*/

const updateStatusArtigo = async (status) => {
    // Recupera o token do LocalStorage
    const token = localStorage.getItem('viver_token');


    let novoStatus;

    switch (status) {
        case 'enviado':
            novoStatus = 'publicado';
            break;
        case 'publicado':
            novoStatus = 'bloqueado';
            break;
        case 'bloqueado':
            novoStatus = 'enviado';
            break;
        default:
            setMensagem({ texto: "Status atual do artigo desconhecido. Impossível atualizar.", tipo: 'erro' });
            return;
    }


    console.log(`Status atual: ${status}, Novo status: ${novoStatus}`); // Log para verificar os status antes de enviar a requisição
    console.log(`Token para autenticação: ${token}`); // Log para verificar o token antes de enviar a requisição
    console.log(`ID do artigo para update: ${artigo.id}`); // Log para verificar o ID do artigo antes de enviar a requisição    

    try {
        const url = `${process.env.REACT_APP_API_URL}/artigo-update-status`;
        const resposta = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}` // Envia o token para autenticação
                
            },
            body: JSON.stringify({
                id: artigo.id,
                uuid: artigo.uuid,
                status: novoStatus
            })
        });

        if (resposta.ok) {
            const dadosRetorno = await resposta.json();
                if (dadosRetorno.status === 'sucesso') {
                    setMensagem({ texto: dadosRetorno.mensagem, tipo: dadosRetorno.status });
                    //Passamos o state para a página de resultado usando o navigate do react-router-dom, que permite enviar um objeto de estado junto com a navegação. Assim, a página de resultado pode acessar esse estado para exibir a mensagem apropriada. Só usaremos a página resultado para exibir mensagens de sucesso. Erros serão exibidos na própria página de cadastro para que o usuário possa corrigir sem perder os dados já preenchidos.
                            navigate('/resultado', { 
                                state: { 
                                    status: dadosRetorno.status,
                                    mensagem: dadosRetorno.mensagem
                                }
                                });
                            setCarregando (false); // Destrava o botão cadastrar após o processamento da requisição
                            return;
                } else {
                    // Se o erro for 401, significa que o token expirou durante a edição
                            if (resposta.status === 401) {
                                localStorage.removeItem('viver_token');
                                navigate('/login', { state: { mensagem: "Sessão expirada. Logue novamente." } });
                            return;
                            }
                            setMensagem({ texto: dadosRetorno.mensagem, tipo: dadosRetorno.status });
                            setCarregando (false); // Destrava o botão cadastrar após o processamento da requisição
                        return;
                }
        }else {
            /// Aqui o PHP enviou um erro o os dados possivelmente vieram vazios (ex: 500 ou 400 Bad Request)
            // ✅ Tenta parsear, mas trata se vier vazio
            let erroRetorno;
            try {
                erroRetorno = await resposta.json();
            } catch {
                erroRetorno = { mensagem: `Erro no servidor: ${resposta.status}`, status: 'erro' };
            }
            setMensagem({ 
                texto: erroRetorno.mensagem || "Erro ao processar.", 
                tipo: erroRetorno.status || 'erro'
            });
            setCarregando(false);
        }   

    } catch (error) {
        setMensagem({ texto: error.message, tipo: 'erro' });
        console.error("Erro ao cadastrar artigo:", error);
        setCarregando (false); // Destrava o botão cadastrar após o processamento da requisição
    }
};


    if (carregando) {
        return <div className="container text-center mt-5"><h3>Carregando artigo...</h3></div>;
    }

    if (!artigo) {
        return null;
    }

    return (
        <div className="container mb-5">
            
            <article>
                {/* Imagem de Capa */}
                {artigo.arquivo && (
                    <figure className="figure w-100 text-center mb-5 pt-5 ">
                        <img 
                            className="img-fluid rounded w-100" 
                            src={`${process.env.REACT_APP_API_URL}/public/assets/imagens/artigos/${artigo.arquivo}`} 
                            alt={artigo.titulo} 
                            style={{ objectFit: 'cover' }}
                        />
                    </figure>
                )}


                {/* Cabeçalho do Artigo */}
                <header className="mb-4 ">
                    <h1 className="fw-bolder mb-1 text-center">{artigo.titulo}</h1>
                    <p className="text-muted fst-italic mb-2 text-sm-end">
                        Publicado por {artigo.nomeAutor} em {new Date(artigo.data).toLocaleDateString()}
                    </p>
                </header>

                {/* Log para verificar os dados do artigo antes de renderizar */}
                {console.log("Dados do artigo para renderização:", artigo)} 
                

                

                {/* Conteúdo do Artigo (Renderizando HTML do Quill) */}
                <section className="ql-container ql-snow border-0">
                    <div 
                        className="ql-editor artigo-conteudo" // Classe do Quill para manter a formatação original
                        style={{ padding: 0 }}
                        dangerouslySetInnerHTML={{ __html: artigo.conteudo }} 
                    />
                </section>
            </article>

             
            <Mensagem mensagem={mensagem.texto} tipo={mensagem.tipo} />


             <nav className="container-fluid d-flex justify-content-start mt-5 mb-4">

                
                {/** Se o artigo estiver com status 'publicado' habilita o botão de compartilhamento */}

                {artigo.status === 'publicado' && (
                    <Botao 
                        className={"btn btn-info me-2 fs-5"} 
                        aoClicar={compartilharArtigo}
                        tipo={"button"}
                        disabled={false}
                    >
                    Compartilhar
                </Botao>
                )}

                {/* Se o artigo estiver no status 'enviado' e o usuário logado for o autor ou admin habilita o botão de edição */}
                {(token && 
                        artigo.status === 'enviado'
                        && ( (usuario?.user === artigo?.autor) || (usuario?.tipo === 'admin') )) 
                && (    

                    <Botao
                        className={"btn btn-primary ms-2 fs-5"}
                        aoClicar={() => navigate('/cadastro-artigo', { state: { 
                            usuario,
                            artigo } })}
                        tipo={"button"}
                        disabled={false}
                    >
                        Editar Artigo
                    </Botao>
                )}

                {/* Neste ponto criarmo um botão para fazer um update no status do artigo. Somente admin e editores  podem mudar status do artigo. */
                /* Regra: 
                    1. Se for Admin: Mostra sempre.
                    2. Se for Editor: Mostra apenas se NÃO for o autor do artigo.
                */}
                
                
                {token &&  
                     (
                        ( usuario?.tipo === 'admin')
                        ||
                        ( (usuario?.tipo === 'editor') && (usuario?.user !== artigo?.autor))
                
                ) && (
                    
                    
                    <Botao 
                        className={"btn btn-success ms-2 fs-5"}
                        //Envia o status atual e o novo status a função updateStatusArtigo, que fará a requisição para a API para atualizar o status do artigo. O novo status será tratado no corpo da função de acordo com o atual. 
                        aoClicar={() => updateStatusArtigo(artigo.status)}
                    >
                        {artigo.status === 'enviado' ? 'Publicar Artigo' : artigo.status === 'publicado' ? 'Bloquear Artigo' : 'Reenviar Artigo'
                        }
                    </Botao>

                )}
            </nav>  
        </div>
    );
}

export default ViewArtigo;
